import React from "react";
import fb from "../assets/images/facebook.png";
import wa from "../assets/images/whatsapp.png";
import yt from "../assets/images/youtube.png";
import inst from "../assets/images/instagram.png";

function SocialIcons({ className }) {
  const links = {
    facebook: "https://www.facebook.com/profile.php?id=61554401090118",
    whatsapp: "https://wa.me/+94750360097",
    youtube: "https://youtube.com/@sachiradilanka-science?si=Fdbuu--bxaUHRbTv",
    instagram: "https://www.instagram.com/sachira_dilanka?igsh=Mm1waTR5Y3h3emt1",
  };

  return (
    <li className={`flex items-center gap-x-2 mt-4 ${className}`}>
      <a href={links.facebook} target="_blank" rel="noopener noreferrer">
        <img src={fb} alt="Facebook" />
      </a>
      <a href={links.youtube} target="_blank" rel="noopener noreferrer">
        <img src={yt} alt="YouTube" />
      </a>
      <a href={links.whatsapp} target="_blank" rel="noopener noreferrer">
        <img src={wa} alt="WhatsApp" />
      </a>
      <a href={links.instagram} target="_blank" rel="noopener noreferrer">
        <img src={inst} alt="Instagram" />
      </a>
    </li>
  );
}

export default SocialIcons;
